export namespace UtilDateTime { // TODO: 使用moment库
  /**
   * 获取相应日期
   * @export
   * @param {string} fmt
   * @param {Date} dt
   * @returns {string}
   */
  export function datetimeFormat(fmt: string, dt: Date): string {
    const o: any = {
      'M+': dt.getMonth() + 1, // 月份
      'd+': dt.getDate(), // 日
      'h+': dt.getHours(), // 小时
      'm+': dt.getMinutes(), // 分
      's+': dt.getSeconds(), // 秒
      'q+': Math.floor((dt.getMonth() + 3) / 3), // 季度
      S: dt.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (dt.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }
    return fmt;
  }

  /**
   * 获取当前时间格式
   * @export
   * @param {string} fmt
   * @returns {string}
   */
  export function nowFormat(fmt: string): string {
    const dt = new Date();
    return UtilDateTime.datetimeFormat(fmt, dt);
  }

  export function getDateTimeFormat(dt: string, fmt = 'yyyy-MM-dd hh:mm:ss'): string {
    if (!!dt) {
      return UtilDateTime.datetimeFormat(fmt, new Date(dt));
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/utils/datetime.ts